import EventBus from '../../common/utils/event-bus';

export default {
	name: 'lst03-list',
	data() {
		return {
			category: ''
		};
	},
	methods: {
		setCategory(category) {
			EventBus.$emit('set-news-category', category);
		}
	}
};



// WEBPACK FOOTER //
// ../source/modules/LST03-list/LST03-list.js